<template>
<form action="">
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Crediteer bon</p>
    </header>
    <section class="modal-card-body" v-show="!creditReceipt">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>Nummer</th>
            <th>Datum</th>
            <th>Prijs</th>
            <th>Artikel</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="receipt in receipts">
            <td>{{receipt.number}}</td>
            <td>{{receipt.date}}</td>
            <td>{{receipt.price}}</td>
            <td>{{receipt.article}}</td>
            <td><button class="button is-warning" type="button" @click="selectCreditReceipt(receipt.id)">Wijzigen</button></td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="modal-card-body" v-show="creditReceipt">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>Nummer</th>
            <th>Datum</th>
            <th>Prijs</th>
            <th>BTW code</th>
            <th>Artikel</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{creditReceipt.number}}</td>
            <td>{{creditReceipt.date}}</td>
            <td>{{creditReceipt.price}}</td>
            <td>{{creditReceipt.vatCode}}</td>
            <td>{{creditReceipt.article}}</td>
          </tr>
        </tbody>
      </table>

      <table class="table is-fullwidth no-border">
        <tbody>
          <tr>
            <td>
              <b>Crediteur</b>
            </td>
            <td>
              <b-field>
                  <b-autocomplete
                      ref="crediteurField"
                      v-model="crediteur.name"
                      :data="filterCrediteuren"
                      :placeholder="`bijv. ${crediteur.data[0] || ''}`"
                      @select="onCrediteurSelect"
                      :keep-first="true"
                      required>
                  </b-autocomplete>
              </b-field>
            </td>
          </tr>
          <tr>
            <td>
              <b>Debiteur</b>
            </td>
            <td>
              <b-field>
                  <b-autocomplete
                      ref="debiteurField"
                      v-model="debiteur.name"
                      :data="filterDebiteuren"
                      :placeholder="`bijv. ${debiteur.data[0] || ''}`"
                      @select="onDebiteurSelect"
                      :keep-first="true"
                      required>
                  </b-autocomplete>
              </b-field>
            </td>
          </tr>
        </tbody>
      </table>

      <div>
        <a @click="deselectCreditReceipt()" class="button is-primary">Terug</a>
        <a @click="creditInvoiceReceiptAndClose(creditReceipt.id)" class="button is-danger is-pulled-right spacing-left-10">Crediteer geselecteerde bon</a>
        <a @click="changeInvoiceReceiptAndClose(creditReceipt.id)" class="button is-danger is-pulled-right">Wijzigen</a>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-danger" type="button" @click="creditAll()">Crediteer alle bonnen</button>
      <button class="button" type="button" @click="close()">Sluiten</button>
    </footer>

    <b-loading :active.sync="isLoading"></b-loading>
  </div>
</form>
</template>

<script>
import Store from '../../store'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'crediteuren',
      'debiteuren'
    ]),
    filterCrediteuren () {
      const result = this.crediteur.data.filter((option) => {
        const crediteur = this.crediteuren.find(function (crediteur) {
          return crediteur.acctName === option
        })

        const isName = option
          .toString()
          .toLowerCase()
          .indexOf(this.crediteur.name.toLowerCase()) >= 0
        const isNumber = this.crediteur.name === crediteur.subNr

        return isName || isNumber
      })
      return result
    },
    filterDebiteuren () {
      const result = this.debiteur.data.filter((option) => {
        const debiteur = this.debiteuren.find(function (debiteur) {
          return debiteur.acctName === option
        })

        const isName = option
          .toString()
          .toLowerCase()
          .indexOf(this.debiteur.name.toLowerCase()) >= 0
        const isNumber = this.debiteur.name === debiteur.subNr

        return isName || isNumber
      })
      return result
    }
  },
  props: {
    id: String,
    receipts: Array,
    type: String
  },
  data () {
    return {
      isLoading: false,
      creditReceipt: '',
      crediteur: {
        data: [],
        name: '',
        selected: null
      },
      debiteur: {
        data: [],
        name: '',
        selected: null
      }
    }
  },
  async created () {
    await this.$store.dispatch('getCrediteuren')
    await this.$store.dispatch('getDebiteuren')

    const crediteuren = this.crediteuren.map((object) => {
      return object.acctName
    })

    const debiteuren = this.debiteuren.map((object) => {
      return object.acctName
    })

    this.crediteur.data = crediteuren
    this.debiteur.data = debiteuren
  },
  methods: {
    async creditInvoiceReceipt (id) {
      this.isLoading = true

      try {
        await Store.dispatch('creditNotePurchaseReceipt', {
          receipt: id,
          purchase: this.id
        })
      } catch (error) {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het crediteren van de bon.'
        })
      } finally {
        this.isLoading = false
      }
    },
    async creditInvoiceReceiptAndClose (id) {
      await this.creditInvoiceReceipt(id)
      this.close()
    },
    async changeInvoiceReceiptAndClose (id) {
      await this.creditInvoiceReceipt(id)

      const debiteur = this.debiteur.selected
      const crediteur = this.crediteur.selected

      await this.$store.dispatch('saveReceiptConcept', {
        id,
        crediteur,
        debiteur
      })

      await this.$store.dispatch('setReceiptState', {
        id,
        state: 'confirm'
      })

      this.close()
    },
    async creditAll () {
      this.isLoading = true

      try {
        await Store.dispatch('creditNotePurchase', this.id)
        this.close()
      } catch (error) {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het crediteren van de inkoop factuur.'
        })
      } finally {
        this.isLoading = false
      }
    },
    selectCreditReceipt (id) {
      this.creditReceipt = this.receipts.find(function (receipt) {
        return receipt.id === id
      })

      this.setCrediteur(this.creditReceipt.crediteur)
      this.setDebiteur(this.creditReceipt.debiteur)
    },
    deselectCreditReceipt () {
      this.creditReceipt = ''
    },
    setCrediteur (id) {
      for (let object of this.crediteuren) {
        if (object.subNr === id) {
          this.$refs.crediteurField.setSelected(object.acctName)
        }
      }
    },
    onCrediteurSelect (object) {
      const crediteur = this.crediteuren.find((crediteur) => {
        return crediteur.acctName === object || crediteur.subNr === object
      })

      if (!crediteur) {
        return
      }

      this.crediteur.selected = crediteur.subNr
    },
    setDebiteur (id) {
      for (let object of this.debiteuren) {
        if (object.subNr === id) {
          this.$refs.debiteurField.setSelected(object.acctName)
        }
      }
    },
    onDebiteurSelect (object) {
      const debiteur = this.debiteuren.find((debiteur) => {
        return debiteur.acctName === object || debiteur.subNr === object
      })

      if (!debiteur) {
        return
      }

      this.debiteur.selected = debiteur.subNr
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoices/creditNote.vue